export default {"src":"/_next/static/media/logo-gradient.e2bfb8a9.svg","height":262,"width":464,"blurWidth":0,"blurHeight":0};